<template>
  <div>
    <v-row>
      <v-col cols="7">
        <v-form @submit.prevent autocomplete="off">
          <v-row>
            <v-col cols="12">
              <gg-card>
                <gg-card-header>
                  Domain Information
                </gg-card-header>
                <gg-card-text>
                  <v-row class="mt-3 px-6">
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        :key="domainFieldName"
                        outlined
                        label="Domain"
                        v-model="model.domain"
                        v-validate="rules[domainFieldName]"
                        :data-vv-name="domainFieldName"
                        data-vv-as="Domain"
                        :error-messages="errors.collect(domainFieldName)"
                        :autocomplete="domainFieldName"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        :key="usernameFieldName"
                        outlined
                        label="Username"
                        v-model="model.username"
                        v-validate="rules[usernameFieldName]"
                        ref="username"
                        :data-vv-name="usernameFieldName"
                        data-vv-as="Username"
                        :error-messages="errors.collect(usernameFieldName)"
                        @focus="createUsernameByDomain"
                        :autocomplete="usernameFieldName"
                      ></gg-text-field>
                    </v-col>
                    <input class="hidden" type="text" value="value" name="username">
                    <input class="hidden" type="password"
                           data-vv-name="passwords"
                           v-model="model.password"
                           ref="password"
                           autocomplete="new-password"
                    >
                    <v-col cols="12" class="py-0 px-0">
                      <compact-password
                        :key="passwordFieldName"
                        outlined
                        label="Password"
                        v-validate="rules[passwordFieldName]"
                        :data-vv-name="passwordFieldName"
                        data-vv-as="Password"
                        :error-messages="errors.collect(passwordFieldName)"
                        with-generator
                        :cpanel-app="'createacct'"
                        v-model="model.password"
                        :autocomplete="passwordFieldName"
                      />
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        type="password"
                        label="Confirm Password"
                        v-model="model.confirmPassword"
                        data-vv-name="confirmPassword"
                        data-vv-as="Confirm Password"
                        v-validate="rules.confirmPassword"
                        :error-messages="errors.collect('confirmPassword')"
                        autocomplete="new-password"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        :key="emailFieldName"
                        outlined
                        label="Email"
                        v-model="model.contactemail"
                        v-validate="rules[emailFieldName]"
                        :data-vv-name="emailFieldName"
                        data-vv-as="Email"
                        :error-messages="errors.collect(emailFieldName)"
                        :autocomplete="emailFieldName"
                      ></gg-text-field>
                    </v-col>
                  </v-row>
                </gg-card-text>
              </gg-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <gg-card>
                <gg-card-header :divider="packageInfoExpanded">
                  <div class="flex justify-between">
                    <div>
                      Package
                    </div>
                    <div>
                      <gg-btn color="primary" icon @click="packageInfoExpanded = !packageInfoExpanded">
                        <v-icon v-if="packageInfoExpanded">mdi-chevron-down</v-icon>
                        <v-icon v-else>mdi-chevron-right</v-icon>
                      </gg-btn>
                    </div>
                  </div>
                </gg-card-header>
                <gg-card-text v-if="packageInfoExpanded">
                  <v-row class="mt-3 px-6">
                    <v-col cols="12" class="py-0 px-0">
                      <gg-select
                        id="package"
                        name="package"
                        key="package"
                        dense
                        outlined
                        label="Choose a Package"
                        v-model="model.msel"
                        :items="packagesOptions"
                        item-value="name"
                        item-text="name"
                        @change="initManualResourceFormData"
                      ></gg-select>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <v-checkbox
                        label="Select Options Manually"
                        v-model="model.manual"
                        style="margin: 0; padding: 0"
                      />
                    </v-col>
                    <v-col v-if="canShowPackageManuallySection && model.manual" cols="12" class="py-0 px-0">
                      <v-checkbox
                        label="Save Manual Settings as a Package"
                        v-model="model.savepkg"
                        style="margin: 0; padding: 0"
                      />
                    </v-col>
                    <v-col v-if="isCreatingNewPackage" cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Package Name"
                        v-model="model.pkgname"
                        v-validate="rules.packageName"
                        data-vv-name="packageName"
                        data-vv-as="packageName"
                        :error-messages="errors.collect('packageName')"
                      ></gg-text-field>
                    </v-col>
                    <v-col v-if="isCreatingNewPackage" cols="12" class="py-0 px-0">
                      <gg-select
                        outlined
                        label="Feature List"
                        v-model="model.featurelist"
                        :items="featureListsOptions"
                      ></gg-select>
                    </v-col>
                  </v-row>
                </gg-card-text>
              </gg-card>
            </v-col>
          </v-row>
          <v-row v-if="model.manual">
            <v-col cols="12">
              <gg-card>
                <gg-card-header :divider="manualResourcesExpanded">
                  <div class="flex justify-between">
                    <div>
                      Manual Resource Options
                    </div>
                    <div>
                      <gg-btn color="primary" icon @click="manualResourcesExpanded = !manualResourcesExpanded">
                        <v-icon v-if="manualResourcesExpanded">mdi-chevron-down</v-icon>
                        <v-icon v-else>mdi-chevron-right</v-icon>
                      </gg-btn>
                    </div>
                  </div>
                </gg-card-header>
                <gg-card-text v-if="manualResourcesExpanded">
                  <v-row class="mt-3 px-6">
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Disk Space Quota (MB)"
                        v-model="model.quota"
                        v-validate="rules.quota"
                        data-vv-name="quota"
                        data-vv-as="Disk Space Quota"
                        :error-messages="errors.collect('quota')"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Monthly Bandwidth Limit (MB)"
                        v-model="model.bwlimit"
                        v-validate="rules.bwlimit"
                        data-vv-name="bwlimit"
                        data-vv-as="Monthly Bandwidth Limit"
                        :error-messages="errors.collect('bwlimit')"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Max FTP Accounts"
                        v-model="model.maxftp"
                        v-validate="rules.maxftp"
                        data-vv-name="maxftp"
                        data-vv-as="Max FTP Accounts"
                        :error-messages="errors.collect('maxftp')"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Max Email Accounts"
                        v-model="model.maxpop"
                        v-validate="rules.maxpop"
                        data-vv-name="maxpop"
                        data-vv-as="Max Email Accounts"
                        :error-messages="errors.collect('maxpop')"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Max Mailing Lists"
                        v-model="model.maxlst"
                        v-validate="rules.maxlst"
                        data-vv-name="maxlst"
                        data-vv-as="Max Mailing Lists"
                        :error-messages="errors.collect('maxlst')"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Max SQL Databases"
                        v-model="model.maxsql"
                        v-validate="rules.maxsql"
                        data-vv-name="maxsql"
                        data-vv-as="Max SQL Databases"
                        :error-messages="errors.collect('maxsql')"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Max Sub Domains"
                        v-model="model.maxsub"
                        v-validate="rules.maxsub"
                        data-vv-name="maxsub"
                        data-vv-as="Max Sub Domains"
                        :error-messages="errors.collect('maxsub')"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Max Parked Domains"
                        v-model="model.maxpark"
                        v-validate="rules.maxpark"
                        data-vv-name="maxpark"
                        data-vv-as="Max Parked Domains"
                        :error-messages="errors.collect('maxpark')"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Max Addon Domains"
                        v-model="model.maxaddon"
                        v-validate="rules.maxaddon"
                        data-vv-name="maxaddon"
                        data-vv-as="Max Addon Domains"
                        :error-messages="errors.collect('maxaddon')"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Max Passenger Applications"
                        v-model="model.maxpassengerapps"
                        v-validate="rules.maxpassengerapps"
                        data-vv-name="maxpassengerapps"
                        data-vv-as="Max Passenger Applications"
                        :error-messages="errors.collect('maxpassengerapps')"
                      ></gg-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-text-field
                        outlined
                        label="Max Quota per Email Address (MB)"
                        v-model="model.max_emailacct_quota"
                        v-validate="rules.max_emailacct_quota"
                        data-vv-name="max_emailacct_quota"
                        data-vv-as="Max Quota per Email Address"
                        :error-messages="errors.collect('max_emailacct_quota')"
                      ></gg-text-field>
                    </v-col>
                  </v-row>
                </gg-card-text>
              </gg-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <gg-card>
                <gg-card-header :divider="generalSettingsExpanded">
                  <div class="flex justify-between">
                    <div>
                      General Settings
                    </div>
                    <div>
                      <gg-btn color="primary" icon @click="generalSettingsExpanded = !generalSettingsExpanded">
                        <v-icon v-if="generalSettingsExpanded">mdi-chevron-down</v-icon>
                        <v-icon v-else>mdi-chevron-right</v-icon>
                      </gg-btn>
                    </div>
                  </div>
                </gg-card-header>
                <gg-card-text v-if="generalSettingsExpanded">
                  <v-row class="mt-3 px-6">
                    <v-col v-if="shallAllowed" cols="12" class="py-0 px-0">
                      <v-checkbox
                        label="Shell Access"
                        v-model="model.hasshell"
                        style="margin: 0; padding: 0"
                      />
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <v-checkbox
                        label="CGI Access"
                        v-model="model.cgi"
                        style="margin: 0; padding: 0"
                      />
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-select
                        outlined
                        label="cPanel Theme"
                        v-model="model.cpmod"
                        :items="themesOptions"
                      ></gg-select>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <gg-select
                        outlined
                        label="Locale"
                        v-model="model.language"
                        v-validate="rules.language"
                        :items="languagesOptions"
                        item-value="value"
                        item-text="label"
                        data-vv-name="language"
                        data-vv-as="language"
                        :error-messages="errors.collect('language')"
                      ></gg-select>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <v-checkbox
                        label="Enable Apache SpamAssassin™"
                        v-model="model.spamassassin"
                        style="margin: 0; padding: 0"
                      />
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <div class="flex">
                        <v-checkbox
                          v-model="model.spambox"
                          :disabled="!model.spamassassin"
                          style="margin: 0; padding: 0"
                        />
                        <div class="v-label" style="padding-top: 1px">
                          Enable Spam Box
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on">mdi-help-circle</v-icon>
                            </template>
                            <div>
                              <p>Save spam messages to a folder.</p>
                              <p>When you disable this option, the system delivers messages flagged as spam to the user’s inbox.</p>
                              <p>You must enable Apache SpamAssassin™ to use the Spam Box feature.</p>
                            </div>
                          </v-tooltip>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </gg-card-text>
              </gg-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <gg-card>
                <gg-card-header :divider="mailSettingsExpanded">
                  <div class="flex justify-between">
                    <div>
                      Mail Routing Settings
                    </div>
                    <div>
                      <gg-btn color="primary" icon @click="mailSettingsExpanded = !mailSettingsExpanded">
                        <v-icon v-if="mailSettingsExpanded">mdi-chevron-down</v-icon>
                        <v-icon v-else>mdi-chevron-right</v-icon>
                      </gg-btn>
                    </div>
                  </div>
                </gg-card-header>
                <gg-card-text v-if="mailSettingsExpanded">
                  <v-row class="mt-n1 px-6">
                    <v-col cols="12" class="py-0 px-0">
                      <v-radio-group
                        class="py-0 px-0"
                        v-model="model.mxcheck"
                      >
                        <div
                          v-for="(mxcheck, i) in mxcheckOptions"
                          :key=i
                        >
                          <v-radio
                            :value=mxcheck.value
                          >
                            <template v-slot:label>
                              <div>{{ mxcheck.label }}</div>
                              <gg-btn v-if="mxcheck.showExpanded" color="primary" icon @click="mxcheck.showExpanded = !mxcheck.showExpanded">
                                <v-icon>mdi-chevron-left</v-icon>
                              </gg-btn>
                              <gg-btn v-else color="primary" icon @click="mxcheck.showExpanded = !mxcheck.showExpanded">
                                <v-icon>mdi-chevron-right</v-icon>
                              </gg-btn>
                            </template>
                          </v-radio>
                          <v-row v-if="mxcheck.showExpanded">
                            <v-col cols="12" v-for="(subitem, index) in mxcheck.expand" :key="index" class="pa-0">
                              <v-list-item v-if="subitem.type === 'list'">
                                <v-list-item-content v-if="subitem.text" class="text-body-2">
                                  <v-list-item-title v-if="subitem.label" class="text-body-1">
                                    {{ subitem.label }}
                                  </v-list-item-title>
                                  {{ subitem.text }}
                                </v-list-item-content>
                              </v-list-item>
                              <p v-else-if="subitem.type === 'paragraph'" class="text-body-2">
                                {{ subitem.text }}
                              </p>
                            </v-col>
                          </v-row>
                        </div>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </gg-card-text>
              </gg-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card>
                <gg-card-header
                  :divider="dnsSettingsExpanded"
                >
                  <div class="flex justify-between">
                    <div>
                      DNS Settings
                    </div>
                    <div>
                      <gg-btn color="primary" icon @click="dnsSettingsExpanded = !dnsSettingsExpanded">
                        <v-icon v-if="dnsSettingsExpanded">mdi-chevron-down</v-icon>
                        <v-icon v-else>mdi-chevron-right</v-icon>
                      </gg-btn>
                    </div>
                  </div>
                </gg-card-header>
                <gg-card-text v-if="dnsSettingsExpanded">
                  <v-row class="mt-3 px-6">
                    <v-col cols="12" class="py-0 px-0">
                      <div v-if="dnsEditingAllowed()" class="flex">
                        <v-checkbox
                          v-model="model.dkim"
                          :disabled="!!model.dmarc"
                          style="margin: 0; padding: 0"
                        />
                        <div class="v-label pt-1">
                          Enable
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="text-decoration-underline">DKIM</span>
                            </template>
                            <span>DomainKeys Identified Mail</span>
                          </v-tooltip>
                          on this account.
                        </div>
                      </div>

                      <div v-if="dnsEditingAllowed()" class="flex">
                        <v-checkbox
                          v-model="model.spf"
                          :disabled="!!model.dmarc"
                          style="margin: 0; padding: 0"
                        />
                        <div class="v-label pt-1">
                          Enable
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="text-decoration-underline">SPF</span>
                            </template>
                            <span>Sender Policy Framework</span>
                          </v-tooltip>
                          on this account.
                        </div>
                      </div>
                      <div v-if="dnsEditingAllowed()" class="flex">
                        <v-checkbox
                          v-model="model.dmarc"
                          style="margin: 0; padding: 0"
                        />
                        <div class="v-label pt-1">
                          Enable
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="text-decoration-underline">DMARC</span>
                            </template>
                            <span>Domain-based Message Authentication Reporting and Conformance</span>
                          </v-tooltip>
                          on this account. (
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="text-decoration-underline">DMARC</span>
                            </template>
                            <span>Domain-based Message Authentication Reporting and Conformance</span>
                          </v-tooltip>
                          requires
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="text-decoration-underline">DKIM</span>
                            </template>
                            <span>DomainKeys Identified Mail</span>
                          </v-tooltip>
                          and
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="text-decoration-underline">SPF</span>
                            </template>
                            <span>Sender Policy Framework</span>
                          </v-tooltip>
                          to be enabled.)
                        </div>
                      </div>

                      <v-checkbox
                        label="Use the nameservers specified at the Domain’s Registrar. (Ignore locally specified nameservers.)"
                        v-model="model.useregns"
                        style="margin: 0; padding: 0"
                      />
                    </v-col>
                  </v-row>
                </gg-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-6 px-3">
              <gg-btn type="submit" :loading="loading" @click="createSubAccount" :disabled="hosting_detail.acct_limit <= hosting_detail.acct_used">
                Create
              </gg-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="5">
        <v-row>
          <v-col cols="12">
            <gg-card>
              <gg-card-header :divider="false">
                <div>
                  Account Limits
                </div>
              </gg-card-header>
              <gg-card-text class="px-7">
                <v-row class="font-bold" style="border-bottom: 2px solid #000000;">
                  <v-col cols="6" sm="6">
                    Limit
                  </v-col>
                  <v-col cols="6" sm="6">
                    Information
                  </v-col>
                </v-row>
                <v-row style="border-bottom: 1px solid #d7dce4;">
                  <v-col cols="3" class="align-self-center">
                    Number of Accounts
                  </v-col>
                  <v-col cols="3" class="align-self-center">
                    <div>
                      <v-progress-linear
                        :value="limits.account"
                        :color="limits.account < 100 ? 'primary' : 'error'"
                        height="15"
                      />
                    </div>
                    <div class="font-bold">{{ hosting_detail.acct_used }} / {{ hosting_detail.acct_limit }}</div>
                  </v-col>
                  <v-col cols="6"></v-col>
                </v-row>
                <v-row style="border-bottom: 1px solid #d7dce4;">
                  <v-col cols="3" class="align-self-center">
                    Disk Space
                  </v-col>
                  <v-col cols="3" class="align-self-center">
                    <div>
                      <v-progress-linear
                        :value="limits.disk"
                        :color="limits.disk < 100 ? 'primary' : 'error'"
                        height="15"
                      >
                      </v-progress-linear>
                    </div>
                    <div class="font-bold">{{ humanFileSize(diskUsed) }} / {{ hosting_detail.disk_limit ? humanFileSize(hosting_detail.disk_limit) : 'Unlimited' }}</div>
                  </v-col>
                  <v-col cols="6" class="align-self-center">
                    Your Disk Usage Limit is calculated based on how much disk space all your accounts have been allocated.
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="align-self-center">
                    Bandwidth
                  </v-col>
                  <v-col cols="3" class="align-self-center">
                    <div>
                      <v-progress-linear
                        :value="limits.bw"
                        :color="limits.bw < 100 ? 'primary' : 'error'"
                        height="15"
                      />
                    </div>
                    <div class="font-bold">{{ humanFileSize(bandwidthUsed) }} / {{ hosting_detail.bw_limit ? humanFileSize(hosting_detail.bw_limit) : 'Unlimited' }}</div>
                  </v-col>
                  <v-col cols="6" class="align-self-center">
                    Your Bandwidth Usage Limit is calculated based on how much bandwidth all your accounts have been allocated.
                  </v-col>
                </v-row>
              </gg-card-text>
            </gg-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Validator } from 'vee-validate'
import { domainValidator } from '@/helpers/validators'
import CompactPassword from '@/components/Common/password/CompactPassword'
import amapi from '@/api/amapi'
import {
  RESELLER_SERVICE_DEFAULT_FEATURE_LIST,
  RESELLER_SERVICE_PRIVILEGE_PACKAGE_ADD,
  RESELLER_SERVICE_DEFAULT_THEME,
  RESELLER_SERVICE_DEFAULT_MAIL_ROUTING,
  RESELLER_SERVICE_PRIVILEGE_DNS_EDIT,
  RESELLER_SERVICE_PRIVILEGE_SHELL_ALLOW,
} from '@/consts/service'
import { percent, humanFileSize } from '@/helpers/helpers'

export default {
  name: 'AccountAdd',
  components: {
    CompactPassword,
  },
  data () {
    return {
      packageInfoExpanded: false,
      manualResourcesExpanded: true,
      generalSettingsExpanded: false,
      mailSettingsExpanded: false,
      dnsSettingsExpanded: false,
      model: {
        domain: '',
        username: '',
        password: '',
        confirmPassword: '',
        contactemail: '',
        msel: '',
        manual: '',
        savepkg: '',
        pkgname: '',
        featurelist: '',
        quota: '',
        bwlimit: '',
        maxftp: '',
        maxpop: '',
        maxlst: '',
        maxsql: '',
        maxsub: '',
        maxpark: '',
        maxaddon: '',
        maxpassengerapps: '',
        max_emailacct_quota: '',
        hasshell: '',
        cgi: '',
        cpmod: '',
        language: 'en',
        spamassassin: true,
        spambox: true,
        mxcheck: 'local',
        dkim: 1,
        spf: 1,
        dmarc: 1,
        useregns: 0,
      },
      mxcheckOptions: [],
      loading: false,
      packagesOptions: [],
      canShowPackageManuallySection: true,
      themesOptions: [],
      languagesOptions: [],
      featureListsOptions: [],
      domainFieldName: 'domain',
      usernameFieldName: 'username',
      passwordFieldName: 'password',
      emailFieldName: 'contactemail',
    }
  },
  computed: {
    ...mapGetters([
      'hosting_detail',
      'getResellerPackages',
      'getResellerFeatureLists',
      'getResellerThemes',
      'getResellerPrivileges',
    ]),
    limits () {
      return {
        account: this.percent(parseInt(this.hosting_detail.acct_used), parseInt(this.hosting_detail.acct_limit)),
        bw: this.percent(this.bandwidthUsed, this.hosting_detail.bw_limit),
        disk: this.percent(this.diskUsed, this.hosting_detail.disk_limit)
      }
    },
    diskUsed () {
      if (Array.isArray(this.hosting_detail.accounts)) {
        return [...this.hosting_detail.accounts].reduce((limit, acc) => {
          if (typeof acc.disklimit === 'string' && acc.disklimit.includes('M')) {
            return limit + parseInt(acc.disklimit) * 1000000
          } else if (typeof acc.disklimit === 'string') {
            console.warn(`Subaccount ${acc.user} has unexpected value of disklimit "${acc.disklimit}"`)
            return limit + parseInt(acc.disklimit)
          } else {
            console.warn(`Subaccount ${acc.user} has unexpected type of disklimit "${acc.disklimit}"`)
            return limit
          }
        }, 0)
      } else {
        return this.hosting_detail.disk_used
      }
    },
    bandwidthUsed () {
      if (Array.isArray(this.hosting_detail.accounts)) {
        const packageBandwidthLimits = {}
        this.getResellerPackages.forEach((resellerPackage) => {
          Object.assign(packageBandwidthLimits, { [resellerPackage.name]: {
            quota: resellerPackage.QUOTA,
            bandwidth: resellerPackage.BWLIMIT,
          } })
        })
        return [...this.hosting_detail.accounts].reduce((limit, acc) => {
          if (packageBandwidthLimits[acc.plan]?.bandwidth) {
            return limit + parseInt(packageBandwidthLimits[acc.plan]?.bandwidth)
          }
          return limit
        }, 0) * 1000000
      } else {
        return this.hosting_detail.bw_used
      }
    },
    isCreatingNewPackage () {
      return this.model.manual && this.model.savepkg
    },
    rules () {
      const validatingRules = {
        confirmPassword: {
          required: true,
          confirmed: 'password'
        },
        password: {
          required: true, pass_strength: 65
        },
      }
      if (this.isCreatingNewPackage) {
        Object.assign(validatingRules, { packageName: { required: true, regex: '^[A-Za-z-_`|.\\0-9 ]+$' } })
      }
      validatingRules[this.domainFieldName] = { required: true, domain: true, }
      validatingRules[this.usernameFieldName] = {
        required: true,
        length: [1, 16],
        is_not: [this.model.password, 'password'],
      }
      validatingRules[this.passwordFieldName] = { required: true, pass_strength: 65 }
      if (this.model.manual) {
        const manualRules = {
          quota: { required: true, min_value: 1 },
          bwlimit: { required: true, min_value: 1 },
          maxftp: { required: true, min_value: 0 },
          maxpop: { required: true, min_value: 0 },
          maxlst: { required: true, min_value: 0 },
          maxsql: { required: true, min_value: 0 },
          maxsub: { required: true, min_value: 0 },
          maxpark: { required: true, min_value: 0 },
          maxaddon: { required: true, min_value: 0 },
          maxpassengerapps: { required: true, min_value: 0 },
          max_emailacct_quota: { required: true, min_value: 1 },
        }
        Object.assign(validatingRules, manualRules)
      }
      if (this.model.contactemail) {
        validatingRules[this.emailFieldName] = { email: true }
      }
      return validatingRules
    },
    shallAllowed () {
      return !!this.getResellerPrivileges[RESELLER_SERVICE_PRIVILEGE_SHELL_ALLOW]
    },
  },
  methods: {
    ...mapActions([
      'createAccountForReseller',
      'fetchResellerPackages',
      'fetchResellerFeatureLists',
      'fetchResellerThemes',
      'getHostingDetail'
    ]),
    percent,
    humanFileSize,
    featureListingAllowed () {
      return !!this.getResellerPrivileges[RESELLER_SERVICE_PRIVILEGE_PACKAGE_ADD]
    },
    dnsEditingAllowed () {
      return !!this.getResellerPrivileges[RESELLER_SERVICE_PRIVILEGE_DNS_EDIT]
    },
    async createSubAccount () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        return
      }
      this.loading = true
      const { ...dataToSend } = this.model
      dataToSend.cgi = Number(dataToSend.cgi)
      dataToSend.spamassassin = Number(dataToSend.spamassassin)
      dataToSend.spambox = dataToSend.spambox ? 'y' : 'n'
      dataToSend.dkim = Number(dataToSend.dkim)
      dataToSend.spf = Number(dataToSend.spf)
      dataToSend.dmarc = Number(dataToSend.dmarc)
      dataToSend.useregns = Number(dataToSend.useregns)
      if (dataToSend.useregns) {
        dataToSend.hasuseregns = 1
      }
      delete dataToSend.manual
      await this.createAccountForReseller(dataToSend)
      this.loading = false
      this.boot()
      this.initFormData()
    },
    createUsernameByDomain () {
      if (this.model.username.length || !this.model.domain.length) {
        return
      }
      this.model.username = (this.model.domain.split('.'))[0]
    },
    initPackageOptions () {
      if (this.featureListingAllowed()) {
        this.packagesOptions.length = 0
        this.packagesOptions.push(...this.getResellerPackages)
      } else {
        this.packagesOptions = ['default']
      }
    },
    initPackageFormData () {
      if (this.featureListingAllowed()) {
        this.model.msel = this.getResellerPackages[0].name
        const packageIndex = this.getResellerPackages.findIndex((pack) => {
          return pack.name === this.model.msel
        })
        this.model.featurelist = this.getResellerPackages[packageIndex].FEATURELIST
        this.canShowPackageManuallySection = true
      } else {
        this.model.msel = 'default'
        this.canShowPackageManuallySection = false
      }
    },
    initManualResourceFormData () {
      const packageIndex = this.getResellerPackages.findIndex((pack) => {
        return pack.name === this.model.msel
      })
      if (this.featureListingAllowed()) {
        this.model.quota = this.getResellerPackages[packageIndex].QUOTA.toString()
        this.model.bwlimit = this.getResellerPackages[packageIndex].BWLIMIT.toString()
        this.model.maxftp = this.getResellerPackages[packageIndex].MAXFTP.toString()
        this.model.maxpop = this.getResellerPackages[packageIndex].MAXPOP.toString()
        this.model.maxlst = this.getResellerPackages[packageIndex].MAXLST.toString()
        this.model.maxsql = this.getResellerPackages[packageIndex].MAXSQL.toString()
        this.model.maxsub = this.getResellerPackages[packageIndex].MAXSUB.toString()
        this.model.maxpark = this.getResellerPackages[packageIndex].MAXPARK.toString()
        this.model.maxaddon = this.getResellerPackages[packageIndex].MAXADDON.toString()
        this.model.maxpassengerapps = this.getResellerPackages[packageIndex].MAXPASSENGERAPPS.toString()
        this.model.max_emailacct_quota = this.getResellerPackages[packageIndex].MAX_EMAILACCT_QUOTA.toString()
      } else {
        this.model.quota = '1024'
        this.model.bwlimit = '1048576'
        this.model.maxftp = '0'
        this.model.maxpop = '0'
        this.model.maxlst = '0'
        this.model.maxsql = '0'
        this.model.maxsub = '0'
        this.model.maxpark = '0'
        this.model.maxaddon = '0'
        this.model.maxpassengerapps = '4'
        this.model.max_emailacct_quota = '1024'
      }
    },
    initGeneralSettingsFormData () {
      this.model.hasshell = false
      this.model.cgi = false
      this.model.cpmod = RESELLER_SERVICE_DEFAULT_THEME
      this.model.language = 'en'
      this.model.spamassassin = true
      this.model.spambox = true
    },
    initMailRoutingFormData () {
      this.model.mxcheck = RESELLER_SERVICE_DEFAULT_MAIL_ROUTING
    },
    initDnsSettingsFormData () {
      if (this.dnsEditingAllowed()) {
        this.model.dkim = true
        this.model.spf = true
        this.model.dmarc = true
      } else {
        this.model.dkim = false
        this.model.spf = false
        this.model.dmarc = false
      }
      this.model.useregns = false
    },
    initThemesOptions () {
      this.themesOptions.length = 0
      this.themesOptions.push(RESELLER_SERVICE_DEFAULT_THEME)
    },
    initFeatureListsOptions () {
      this.featureListsOptions.length = 0
      this.featureListsOptions.push(RESELLER_SERVICE_DEFAULT_FEATURE_LIST, ...this.getResellerFeatureLists)
    },
    initLanguagesOptions () {
      this.languagesOptions.length = 0
      this.languagesOptions.push({ label: 'English', value: 'en' })
    },
    initMxcheckOptions () {
      this.mxcheckOptions.length = 0
      this.mxcheckOptions.push(
        {
          showExpanded: false,
          value: 'auto',
          label: 'Automatically Detect Configuration (recommended)',
          expand: [
            {
              type: 'list',
              label: 'Local Mail Exchanger',
              text: 'If the lowest numbered mail exchanger points to an IP address on this server, the server will be configured to accept mail locally and from outside the server.',
            },
            {
              type: 'list',
              label: 'Backup Mail Exchanger',
              text: 'If a mail exchanger that is not the lowest numbered mail exchanger points to an IP address on this server, the server will be configured to act as a backup mail exchanger.',
            },
            {
              type: 'list',
              label: 'Remote Mail Exchanger',
              text: 'If there are no mail exchangers that point to an IP address on this server, the server will not accept mail locally and will send mail to the lowest MX record.',
            },
            {
              type: 'paragraph',
              text: 'Note: It is not possible to automatically detect an MX configuration if the MX entries do not resolve (for example, if you mistype a domain name or enter one that does not exist). If your MX configuration is set to auto and you add or edit an MX record that does not resolve, you will see a warning and the MX configuration will default to the last known setting.',
            },
            {
              type: 'paragraph',
              text: 'If you have IP addresses that are not bound to any network device on this server and you would like automatic selection to consider them as local, you can edit the list of additional local IP addresses',
            },
          ]
        },
        {
          showExpanded: false,
          value: 'local',
          label: 'Local Mail Exchanger',
          expand: [
            {
              type: 'paragraph',
              text: 'Configure the server to always accept mail. Mail will be delivered locally on the server whenever it is sent from the server or outside the server.',
            },
          ]
        },
        {
          showExpanded: false,
          value: 'secondary',
          label: 'Backup Mail Exchanger',
          expand: [
            {
              type: 'paragraph',
              text: 'Configure the server as a backup mail exchanger. Mail will be held until a lower number mail exchanger is available.',
            },
          ]
        },
        {
          showExpanded: false,
          value: 'remote',
          label: 'Remote Mail Exchanger',
          expand: [
            {
              type: 'paragraph',
              text: 'Configure the server as a backup mail exchanger. Mail will be held until a lower number mail exchanger is available.',
            },
          ]
        },
      )
    },

    resetFieldNames () {
      const ending = Math.random().toString(36).substring(2, 5)
      this.domainFieldName = `domain-${ending}`
      this.usernameFieldName = `username-${ending}`
      this.passwordFieldName = `password-${ending}`
      this.emailFieldName = `email-${ending}`
    },

    initFormData () {
      this.initPackageFormData()
      this.initPackageOptions()
      this.initManualResourceFormData()
      this.initGeneralSettingsFormData()
      this.initMailRoutingFormData()
      this.initDnsSettingsFormData()
      this.initFeatureListsOptions()
      this.initThemesOptions()
      this.initLanguagesOptions()
      this.initMxcheckOptions()
      this.resetFieldNames()
    },

    async boot () {
      const promises = [
        this.fetchResellerPackages(),
        this.fetchResellerThemes({ id: this.$route.params.hostingid, }),
        this.getHostingDetail()
      ]
      if (this.featureListingAllowed()) {
        promises.push(this.fetchResellerFeatureLists())
      }
      await Promise.all(promises)
    },
  },
  watch: {
    'model.dmarc' (newValue) {
      if (newValue) {
        this.model.spf = 1
        this.model.dkim = 1
      }
    },
  },

  async created () {
    const id = this.$route.params.hostingid
    const cpanelPasswordStrengthValidator = {
      getMessage (field) {
        return `Field "${field}" is not a strong.`
      },
      async validate (value, args) {
        const response = await amapi.makecall('cpanel_passwordstrength', {
          id: id,
          password: value
        })
        return response.strength >= args[0]
      },
    }
    const isNotValidator = {
      getMessage (field, args) {
        return `Field "${field}" can not be the same as the ${args[1]}`
      },
      async validate (value, args) {
        return value !== args[0]
      },
    }

    Validator.extend('domain', domainValidator)
    Validator.extend('pass_strength', cpanelPasswordStrengthValidator)
    Validator.extend('is_not', isNotValidator)
    await this.boot()
    this.initFormData()
  }

}
</script>
